import script from "./CaseInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./CaseInfoModal.vue?vue&type=style&index=0&id=d81c9aa0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d81c9aa0"]])

export default __exports__